import requests from '../../services/request'
import store from '../store'

const language = JSON.parse(localStorage.getItem('language'))
const initialState = { status: { loggedIn: false }, workflow: null, user: null, language }

export const auth = {
  namespaced: true,
  state: initialState,
  actions: {
    login: async ({ commit }, data) => {
      store.commit('set_loading', true)
      return requests
        .postService('auth/admin_login', data)
        .then(
          (resp) => {
            let user = resp.data.data
            localStorage.setItem('user', JSON.stringify(user))
            commit('adminLoginSuccess', user)
            return Promise.resolve(resp.data.data)
          },
          (error) => {
            return Promise.reject(error)
          }
        )
        .finally(() => {
          store.commit('set_loading', false)
        })
    },
    workflowLogin: async ({ commit }, data) => {
      store.commit('set_loading', true)
      return requests
        .postService(
          'auth/workflowLogin/' + data.workflow_id + '/' + data.signer_id,
          data.workflow
        )
        .then(
          (resp) => {
            if (resp.data.data === 'REVOKED') {
              return Promise.resolve('REVOKED')
            } else {
              let data = resp.data.data
              let workflow = data.workflow
              let user = data.user

              let header = {
                workflow_id: workflow.workflow_id,
                signer_id: workflow.signer_id,
                accessToken: workflow.accessToken
              }

              if (workflow.workflow_id) {
                localStorage.setItem('header', JSON.stringify(header))
                localStorage.setItem('workflow', JSON.stringify(workflow))
                localStorage.setItem('user', JSON.stringify(user))
                localStorage.setItem('language', JSON.stringify('de'))
                commit('set_language', 'de')
              }
              commit('loginSuccess', data)

              return Promise.resolve(workflow)
            }
          },
          (error) => {
            commit('loginFailure')
            return Promise.reject(error)
          }
        )
        .finally(() => {
          store.commit('set_loading', false)
        })
    },
    checkWorkflowStatus: async ({ commit }, data) => {
      store.commit('set_loading', true)
      return requests
        .postService('workflow/checkWorkflow', data)
        .then(
          (resp) => {
            return Promise.resolve(resp.data.data)
          },
          (error) => {
            return Promise.reject(error)
          }
        )
        .finally(() => {
          store.commit('set_loading', false)
        })
    },
    logout({ commit }) {
      store.commit('set_loading', true)
      localStorage.clear()
      sessionStorage.clear()
      commit('logout')
      store.commit('set_loading', false)
    },
    logoutAdmin({ }) {
      store.commit('set_loading', true)
      return requests
        .deleteService('auth/logoutAdmin')
        .then(
          () => {
            sessionStorage.clear()
            //window.location.reload(); Disabled because logoutAdmin is called on creation of adminLogin
          },
          (error) => {
            return Promise.reject(error)
          }
        )
        .finally(() => {
          store.commit('set_loading', false)
        })
    },
    /*
            registerTrial: async({ commit }, data) => {
                return request.postService('auth/registerTrial', data).then(resp => {
                    return Promise.resolve(resp.data.data);
                }, error => { return Promise.reject(error) })
            },
            */
    register({ commit }, user) {
      store.commit('set_loading', true)
      return requests
        .postService('account/addAccountAdministrator', user)
        .then(
          (resp) => {
            return Promise.resolve(resp)
          },
          (error) => {
            return Promise.reject(error)
          }
        )
        .finally(() => {
          store.commit('set_loading', false)
        })
    },
    registerOrg({ commit }, user) {
      store.commit('set_loading', true)
      return requests
        .postService('account/addTestAccount', user)
        .then(
          (resp) => {
            return Promise.resolve(resp)
          },
          (error) => {
            return Promise.reject(error)
          }
        )
        .finally(() => {
          store.commit('set_loading', false)
        })
    },
    forgot({ commit }, email) {
      store.commit('set_loading', true)
      return requests
        .postService('auth/forgotPassword', { email })
        .then(
          (resp) => {
            return Promise.resolve(resp)
          },
          (error) => {
            return Promise.reject(error)
          }
        )
        .finally(() => {
          store.commit('set_loading', false)
        })
    },
    reset({ commit }, payload) {
      store.commit('set_loading', true)
      let queryString = new URLSearchParams(payload.query).toString()
      return requests
        .postService('auth/resetPassword?' + queryString, payload.user)
        .then(
          (resp) => {
            return Promise.resolve(resp)
          },
          (error) => {
            return Promise.reject(error)
          }
        )
        .finally(() => {
          store.commit('set_loading', false)
        })
    },
    checkPath({ commit }, path) {
      return requests.postService('auth/checkPath', path).then(
        (resp) => {
          return Promise.resolve(resp.data.data)
        },
        (error) => {
          return Promise.reject(error)
        }
      )
    },
  },
  getters: {
    status(state) {
      return state.status
    },
    workflow(state) {
      return state.workflow
    },
    language(state) {
      return state.language
    },
    user(state) {
      return state.user
    },
  },
  mutations: {
    adminLoginSuccess(state, user) {
      state.user = user
    },
    loginSuccess(state, data) {
      state.status.loggedIn = true
      state.user = data.user
      state.workflow = data.workflow
    },
    loginFailure(state) {
      state.status.loggedIn = false
      state.workflow = null
      state.user = null
    },
    logout(state) {
      state.status.loggedIn = false
      state.workflow = null
      state.user = null
    },
    set_language(state, locale) {
      state.language = locale
    },
    set_user(state, user) {
      state.user = user
    },
    set_loggedIn(state, status) {
      state.status.loggedIn = status
    },
    set_workflow(state, workflow) {
      state.workflow = workflow
    },
  },
}
